<template>
  <v-date-input
    :id="id"
    :ref="refName"
    v-bind="$attrs"
    v-model="pValue"
    :label="label"
    :color="color"
    :hint="hint"
    :variant="variant"
    :dark="dark"
    :persistent-hint="!!hint"
    :rules="rules"
    :min="min"
    :max="max"
    @keyup.enter="$emit('onEnter')"
    @update:model-value="onInputChanged($event)"
  >
    <template v-if="icon" #prepend>
      <v-icon color="primary"> {{ icon }}</v-icon>
    </template>

    <template #append>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-icon
            class="selector-default-help-icon"
            color="grey"
            size="18"
            v-bind="props"
          >
            mdi-help
          </v-icon>
        </template>
        <span>{{ helpText }}</span>
      </v-tooltip>
    </template>
  </v-date-input>
</template>
  
  
  <script>
import { VDateInput } from "vuetify/labs/VDateInput";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "HelpDateInput",
  components: {
    VDateInput,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: () => uuidv4(),
    },
    textarea: {
      default: false,
      type: Boolean,
    },
    value: {},
    rules: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    min: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    hint: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "filled",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    timeout: {
      type: Number,
      default: 0,
    },
    tooltipAttrs: {
      type: Object,
      default: () => ({
        bottom: true,
      }),
    },
    icon: {
      type: String,
      default: "",
    },
  },
  emits: ["onSearch", "update:modelValue"],
  computed: {
    refName() {
      return `${this.id}-help-input`;
    },
  },
  data() {
    return {
      pValue: this.value,
    };
  },
  methods: {
    hasError() {
      const hasError = this.$refs[this.refName].errorMessages.length > 0;

      return hasError;
    },
    onInputChanged(event) {
      this.$emit("update:modelValue", event);
    },

    proxyKeydown(e) {
      console.log("PROXY");

      this.$emit(
        "keydown",
        new KeyboardEvent("keydown", {
          keyCode: 40,
        }),
        e
      );
    },
  },
};
</script>
  
  
  <style lang="scss" scoped>
.help-input {
  align-items: flex-end;
  .help-input-icon {
    margin-bottom: 24px;
  }
  .help-text {
    font-size: 2.6rem !important;
  }
}
</style>